/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAssignmentUser } from './ApiAssignmentUser';
import {
    ApiAssignmentUserFromJSON,
    ApiAssignmentUserFromJSONTyped,
    ApiAssignmentUserToJSON,
    ApiAssignmentUserToJSONTyped,
} from './ApiAssignmentUser';

/**
 * 
 * @export
 * @interface ApiAlertAssignment
 */
export interface ApiAlertAssignment {
    /**
     * 
     * @type {number}
     * @memberof ApiAlertAssignment
     */
    id?: number;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiAlertAssignment
     */
    assignee: ApiAssignmentUser;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiAlertAssignment
     */
    assigner: ApiAssignmentUser;
    /**
     * 
     * @type {Date}
     * @memberof ApiAlertAssignment
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiAlertAssignment
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiAlertAssignment
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the ApiAlertAssignment interface.
 */
export function instanceOfApiAlertAssignment(value: object): value is ApiAlertAssignment {
    if (!('assignee' in value) || value['assignee'] === undefined) return false;
    if (!('assigner' in value) || value['assigner'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    return true;
}

export function ApiAlertAssignmentFromJSON(json: any): ApiAlertAssignment {
    return ApiAlertAssignmentFromJSONTyped(json, false);
}

export function ApiAlertAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAlertAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'assignee': ApiAssignmentUserFromJSON(json['assignee']),
        'assigner': ApiAssignmentUserFromJSON(json['assigner']),
        'createdTime': (new Date(json['createdTime'])),
        'startTime': (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

export function ApiAlertAssignmentToJSON(json: any): ApiAlertAssignment {
    return ApiAlertAssignmentToJSONTyped(json, false);
}

export function ApiAlertAssignmentToJSONTyped(value?: ApiAlertAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assignee': ApiAssignmentUserToJSON(value['assignee']),
        'assigner': ApiAssignmentUserToJSON(value['assigner']),
        'createdTime': value['createdTime'].toISOString(),
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
    };
}

